import {
  registerWidget,
  DME,
  DMEData,
  dmeConfig,
  generalSettings,
} from "dmeditor";

interface Entity {
  image?: string;
  name?: string;
  description?: string;
}

export const CollegeMatchRender = (props: DME.WidgetRenderProps<Entity>) => {
  const {
    blockNode: { data },
  } = props;

  const { image, name, description } = data;

  return (
    <div className="">
      <div className="flex-1 flex items-center justify-center ">
        <div className="overflow-hidden rounded-md bg-white w-1/2">
          <div className="w-full">
            <img src={dmeConfig.general.imagePath(image || "")} alt="" />
          </div>
          <div className="p-4">
            <div className="flex gap-x-6 items-center">
              <span className="text-lg font-semibold">{name}</span>
              <span className="text-green-400 text-sm">99% Match</span>
            </div>
            <div>
              <span className="text-gray-700">{description}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default () => {
  registerWidget(
    {
      type: "mf-collegematch",
      icon: "matchfit",
      name: "Colleage match",
      category: "basic",
      settings: [
        { name: "Image", settingComponent: "image", property: ".image" },
        { name: "Name", settingComponent: "input", property: ".name" },
        {
          name: "Description",
          settingComponent: "input",
          property: ".description",
        },
        ...generalSettings,
      ],
      events: {
        updateData: () => {},
        createBlock: (): DMEData.CreatedBlock => {
          return {
            type: "mf-collegematch",
            data: {},
          };
        },
      },
    },
    {
      render: CollegeMatchRender,
    }
  );
};
